export default function slugify(text) {
  return (text || "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/&amp;/g, "and")      // "&amp;" → "and"
    .replace(/&/g, "and")           // "&" → "and"
    .replace(/['"]/g, "")           // remove quotes
    .replace(/[^a-z0-9]+/g, "-")    // non-alphanumeric → dash
    .replace(/^-+|-+$/g, "");       // trim leading/trailing dashes
}